import _classCallCheck from "/tmp/323738e2/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/tmp/323738e2/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/tmp/323738e2/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/tmp/323738e2/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/tmp/323738e2/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/tmp/323738e2/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import { createElement, forwardRef, PureComponent, createRef } from 'react';
import { Animate } from 'react-simple-animate';
import FlipNumbers from 'react-flip-numbers';

function debounce(func, wait) {
  var timeout;
  return function () {
    // @ts-ignore
    var context = this;
    var args = arguments;

    var later = function later() {
      timeout = null;
      func.apply(context, args);
    };

    var callNow = !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

function findElementXandY(e) {
  var rect = e.target.getBoundingClientRect();
  return {
    x: e.clientX || e.touches[0].clientX - rect.left,
    y: e.clientY || e.touches[0].clientY - rect.top
  };
}

var calculateDragDistance = function calculateDragDistance(_ref) {
  var dragDistance = _ref.dragDistance,
      maxPositionX = _ref.maxPositionX,
      totalStepsNumber = _ref.totalStepsNumber,
      min = _ref.min;
  var result = dragDistance ? dragDistance / (maxPositionX / totalStepsNumber) : 0;
  return Math.ceil(result + min);
};

var calculatePosition = function calculatePosition(padding, buttonSize, _ref2) {
  var width = _ref2.width,
      value = _ref2.value,
      min = _ref2.min,
      totalStepsNumber = _ref2.totalStepsNumber;
  var maxPositionX = width - buttonSize - padding * 2;
  var arrowKeyPerClickDistance = maxPositionX / totalStepsNumber;
  var position = (value - min) * arrowKeyPerClickDistance;
  if (position < 0) return 0;
  if (position < padding) return padding;
  return position > maxPositionX ? maxPositionX : position;
};

function getRangedPositionX(_ref3) {
  var dragX = _ref3.dragX,
      maxPositionX = _ref3.maxPositionX,
      padding = _ref3.padding;

  if (padding && dragX <= padding) {
    return padding;
  }

  if (dragX <= 0) {
    return 0;
  }

  if (dragX >= maxPositionX) {
    return maxPositionX;
  }

  return dragX;
}

var getMaxScrollDistance = function getMaxScrollDistance(width, buttonSize, padding) {
  return width - buttonSize - padding;
};

var getDistancePerMove = function getDistancePerMove(width, numberSteps) {
  return width / numberSteps;
};

var getTouchPosition = function getTouchPosition(touchX, left, buttonSize) {
  return touchX - left - buttonSize / 2;
};

var getMousePosition = function getMousePosition(dragX, previousClientX, clientX) {
  return dragX - (previousClientX - clientX);
};

function createArrayWithNumbers(length) {
  return Array.from({
    length: length
  }, function (_, k) {
    return k + 1;
  });
}

var SliderIndicator = function SliderIndicator(_ref4) {
  var amount = _ref4.amount,
      color = _ref4.color,
      isThin = _ref4.isThin,
      barColor = _ref4.barColor,
      hasTickMarks = _ref4.hasTickMarks;
  return createElement("div", {
    style: Object.assign({
      display: 'flex',
      width: '100%',
      justifyContent: 'space-around',
      minHeight: '10px',
      pointerEvents: 'none'
    }, isThin ? {
      background: barColor,
      borderRadius: '4px'
    } : {
      paddingTop: '15px'
    })
  }, hasTickMarks && createArrayWithNumbers(amount > 50 ? 50 : amount).map(function (index) {
    return createElement("span", {
      style: {
        height: '10px',
        width: '1px',
        background: color
      },
      key: index
    });
  }));
};

var bubbleWithTail = 'M38.8,19.9C38.8,30.4,19.9,63,19.9,63S1,30.4,1,19.9S9.5,1,19.9,1S38.8,9.5,38.8,19.9z';
var bubble = 'M38.8,43.9c0,10.4-8.5,18.9-18.9,18.9S1,54.4,1,43.9S9.5,24,19.9,24S38.8,33.5,38.8,43.9z';
var commonAnimationProps = {
  easeType: 'cubic-bezier(0.86, 0, 0.07, 1)',
  start: {
    transform: 'translateY(0)'
  }
};
var flipNumberProps = {
  height: 14,
  width: 9,
  color: 'black',
  background: 'white',
  perspective: 370,
  duration: 0.4,
  play: true,
  numberStyle: {
    outline: '1px solid transparent'
  },
  disabled: false
};
var Controller = forwardRef(function Controller(_ref5, ref) {
  var onFocus = _ref5.onFocus,
      onBlur = _ref5.onBlur,
      _ref5$controllerHeigh = _ref5.controllerHeight,
      controllerHeight = _ref5$controllerHeigh === void 0 ? 0 : _ref5$controllerHeigh,
      _ref5$controllerWidth = _ref5.controllerWidth,
      controllerWidth = _ref5$controllerWidth === void 0 ? 0 : _ref5$controllerWidth,
      height = _ref5.height,
      dragX = _ref5.dragX,
      showBubble = _ref5.showBubble,
      isControlByKeyBoard = _ref5.isControlByKeyBoard,
      value = _ref5.value,
      onMouseDown = _ref5.onMouseDown,
      onInteractEnd = _ref5.onInteractEnd,
      barColor = _ref5.barColor,
      textBackgroundColor = _ref5.textBackgroundColor,
      textColor = _ref5.textColor,
      isThin = _ref5.isThin,
      isTouchDevice = _ref5.isTouchDevice,
      disabled = _ref5.disabled,
      shouldDisplayValue = _ref5.shouldDisplayValue,
      customController = _ref5.customController,
      max = _ref5.max,
      min = _ref5.min,
      shouldAnimateNumber = _ref5.shouldAnimateNumber,
      isFocusing = _ref5.isFocusing,
      focusStyle = _ref5.focusStyle;
  var controllerRootRef = (ref || {}).controllerRootRef;
  var controllerRef = (ref || {}).controllerRef;
  var top = (isThin ? height - controllerHeight : height - controllerHeight) / 2;

  if (customController) {
    top = isThin ? (height - controllerHeight) / 2 : height - controllerHeight;
  }

  return createElement("div", Object.assign({}, {
    onClick: function onClick(e) {
      if (typeof e.cancelable !== 'boolean' || e.cancelable) e.stopPropagation();
    },
    onFocus: onFocus,
    onBlur: onBlur
  }, isTouchDevice ? {} : {
    onMouseDown: onMouseDown,
    onMouseUp: onInteractEnd
  }, {
    tabIndex: 0,
    style: Object.assign({
      top: "".concat(top, "px"),
      position: 'absolute',
      cursor: disabled ? 'not-allowed' : '-webkit-grab',
      transform: "translateX(".concat(dragX, "px)"),
      transition: isControlByKeyBoard ? '0.15s all ease-in' : '0s all',
      width: controllerWidth,
      height: controllerHeight - 10,
      outline: 'none'
    }, isTouchDevice ? {
      pointerEvents: 'none'
    } : null),
    role: "slider",
    "aria-valuenow": value,
    "aria-valuemin": min,
    "aria-valuemax": max,
    "aria-valuetext": value.toString(),
    ref: controllerRootRef
  }), !customController && createElement(Animate, Object.assign({
    play: showBubble
  }, commonAnimationProps, {
    duration: showBubble ? 0.2 : 0.3,
    start: {
      transform: 'translateY(0)'
    },
    end: {
      transform: "translateY(-".concat(isThin ? 32 : 22, "px) scale(1.65)")
    },
    easeType: "cubic-bezier(0.86, 0, 0.07, 1)",
    render: function render(_ref6) {
      var style = _ref6.style;
      return createElement("svg", {
        style: Object.assign({
          position: 'absolute',
          top: '-25px',
          left: 0
        }, style),
        x: "0px",
        y: "0px",
        width: "".concat(controllerHeight, "px"),
        height: "64px",
        viewBox: "0 0 40 64"
      }, createElement("path", {
        style: {
          transition: '0.3s all',
          fill: barColor
        },
        d: showBubble ? bubbleWithTail : bubble
      }));
    }
  })), createElement(Animate, Object.assign({
    play: showBubble
  }, commonAnimationProps, {
    end: {
      transform: "translateY(-".concat(isThin ? 58 : 48, "px) scale(1.3)")
    },
    duration: showBubble ? 0.3 : 0.1,
    render: function render(_ref7) {
      var style = _ref7.style;
      return customController ? customController({
        ref: controllerRef,
        value: value
      }) : createElement("div", {
        style: Object.assign({
          background: textBackgroundColor,
          height: "".concat(controllerHeight, "px"),
          width: "".concat(controllerHeight, "px"),
          borderRadius: '50%',
          position: 'absolute'
        }, isFocusing && !isTouchDevice ? {
          boxShadow: focusStyle || 'rgb(0, 0, 0) 0px 0px 6px'
        } : null, style),
        "aria-hidden": "true"
      }, shouldDisplayValue && createElement("span", {
        style: Object.assign({
          position: 'absolute',
          left: 0,
          width: "".concat(controllerHeight, "px"),
          color: textColor,
          fontWeight: 600
        }, shouldAnimateNumber ? {
          top: '10px'
        } : {
          top: 0,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontSize: '15px',
          height: "".concat(controllerHeight, "px")
        })
      }, shouldAnimateNumber ? createElement(FlipNumbers, Object.assign({}, flipNumberProps, {
        numbers: value.toString()
      })) : value));
    }
  })));
});

var isTouchDevice = function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
};

function preventScrollOnMobile() {
  var _this = this;

  var originalOnTouchMove;

  var preventDefault = function preventDefault(e) {
    return e.preventDefault();
  };

  var preventAction = function preventAction(e) {
    // @ts-ignore
    if (!_this.isTouching) return;
    if (e) preventDefault(e);
    document.addEventListener('touchmove', preventDefault, {
      passive: false
    });
    return false;
  };

  if (!preventAction()) {
    originalOnTouchMove = document.ontouchmove;
  }

  document.ontouchmove = preventAction;
  document.ontouchmove = preventAction; // no joke: only the second one (.ontouchmove) works on mobile safari :)

  return function () {
    document.ontouchmove = originalOnTouchMove;
    document.removeEventListener('touchmove', preventDefault);
  };
}

var colors = {
  white: '#fff',
  lightBlue: '#3562cd',
  blue: '#244BA8'
};
var delayMsForAnimation = 200;

var Slider =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Slider, _PureComponent);

  function Slider() {
    var _this2;

    _classCallCheck(this, Slider);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(Slider).apply(this, arguments));
    _this2.state = {
      dragX: 0,
      showBubble: false,
      isFocusing: false
    };
    _this2.isControlByKeyBoard = false;
    _this2.wrapperRef = createRef();
    _this2.controllerRootRef = createRef();
    _this2.touchDevice = isTouchDevice();
    _this2.controllerRef = createRef();
    _this2.maxScrollDistance = 0;
    _this2.arrowKeyPerClickDistance = 0;
    _this2.controllerHeight = _this2.props.controllerHeight || 0;
    _this2.controllerWidth = _this2.props.controllerWidth || 0;
    _this2.clientX = 0;
    _this2.value = 0;
    _this2.isTouching = false;
    _this2.totalStepsNumber = _this2.props.max - _this2.props.min;
    _this2.calculatePositionWithOffset = calculatePosition.bind(null, _this2.props.padding, _this2.controllerHeight);

    _this2.restoreTouchMove = function () {};

    _this2.onResize = debounce(function () {
      if (!_this2.wrapperRef.current) return;

      var _this2$wrapperRef$cur = _this2.wrapperRef.current.getBoundingClientRect(),
          width = _this2$wrapperRef$cur.width;

      var _this2$props = _this2.props,
          min = _this2$props.min,
          padding = _this2$props.padding;
      _this2.maxScrollDistance = getMaxScrollDistance(width, _this2.controllerWidth, padding);
      _this2.arrowKeyPerClickDistance = getDistancePerMove(_this2.maxScrollDistance, _this2.totalStepsNumber);

      _this2.setState({
        dragX: _this2.calculatePositionWithOffset({
          width: width,
          value: _this2.value,
          min: min,
          totalStepsNumber: _this2.totalStepsNumber
        })
      });
    }, 1000);

    _this2.commonOnStart = function (e) {
      e.stopPropagation();
      _this2.isControlByKeyBoard = false;

      _this2.setState({
        showBubble: true
      });
    };

    _this2.onTouchStart = function (e) {
      var _this2$props2 = _this2.props,
          padding = _this2$props2.padding,
          disabled = _this2$props2.disabled;
      if (disabled) return;
      _this2.isTouching = true;
      _this2.restoreTouchMove = preventScrollOnMobile.call(_assertThisInitialized(_assertThisInitialized(_this2)));

      var _this2$wrapperRef$cur2 = _this2.wrapperRef.current.getBoundingClientRect(),
          left = _this2$wrapperRef$cur2.left;

      _this2.commonOnStart(e);

      _this2.setState({
        dragX: getRangedPositionX({
          padding: padding,
          dragX: getTouchPosition(e.targetTouches[0].pageX, left, _this2.controllerWidth),
          maxPositionX: _this2.maxScrollDistance
        })
      });

      document.addEventListener('touchend', _this2.onInteractEnd);
    };

    _this2.onMouseDown = function (e) {
      if (_this2.touchDevice) return;
      if (_this2.props.disabled) return;
      document.addEventListener('mousemove', _this2.onMouseMove);
      document.addEventListener('mouseup', _this2.onInteractEnd);

      _this2.commonOnStart(e);

      _this2.clientX = e.clientX;
    };

    _this2.onInteractEnd = function (e) {
      e.stopPropagation();
      _this2.isTouching = false;

      _this2.setState({
        showBubble: false
      });

      document.removeEventListener('touchend', _this2.onInteractEnd);
      document.removeEventListener('mousemove', _this2.onMouseMove);
      document.removeEventListener('mouseup', _this2.onInteractEnd);

      _this2.restoreTouchMove();

      _this2.calculateValueAndUpdateStore();
    };

    _this2.onTouchMove = function (e) {
      e.stopPropagation();

      var _this2$wrapperRef$cur3 = _this2.wrapperRef.current.getBoundingClientRect(),
          left = _this2$wrapperRef$cur3.left;

      var _this2$props3 = _this2.props,
          padding = _this2$props3.padding,
          disabled = _this2$props3.disabled;
      if (disabled) return;

      _this2.setState({
        dragX: getRangedPositionX({
          padding: padding,
          dragX: getTouchPosition(e.targetTouches[0].pageX, left, _this2.controllerWidth),
          maxPositionX: _this2.maxScrollDistance
        })
      });
    };

    _this2.onMouseMove = function (e) {
      e.stopPropagation();
      var dragX = _this2.state.dragX;
      var _this2$props4 = _this2.props,
          padding = _this2$props4.padding,
          disabled = _this2$props4.disabled;
      if (disabled) return;

      _this2.setState({
        dragX: getRangedPositionX({
          padding: padding,
          dragX: getMousePosition(dragX, _this2.clientX, e.clientX),
          maxPositionX: _this2.maxScrollDistance
        })
      });

      _this2.clientX = e.clientX;
    };

    _this2.onFocus = function () {
      _this2.setState({
        isFocusing: true
      });

      document.addEventListener('keydown', _this2.onKeyEvent);
    };

    _this2.onBlur = function () {
      _this2.setState({
        isFocusing: false
      });

      document.removeEventListener('keydown', _this2.onKeyEvent);
    };

    _this2.onClick = function (e) {
      var _this2$props5 = _this2.props,
          padding = _this2$props5.padding,
          disabled = _this2$props5.disabled;
      if (disabled) return;

      var _e$target$getBounding = e.target.getBoundingClientRect(),
          left = _e$target$getBounding.left;

      var _findElementXandY = findElementXandY(e),
          x = _findElementXandY.x;

      _this2.isControlByKeyBoard = true;
      clearTimeout(_this2.timer);

      _this2.setState({
        dragX: getRangedPositionX({
          padding: padding,
          dragX: getTouchPosition(x, left, _this2.controllerWidth),
          maxPositionX: _this2.maxScrollDistance
        })
      });

      _this2.timer = setTimeout(function () {
        _this2.calculateValueAndUpdateStore();
      }, delayMsForAnimation);

      _this2.controllerRootRef.current.focus();
    };

    _this2.onKeyEvent = function (e) {
      _this2.isControlByKeyBoard = true;
      var dragX = _this2.state.dragX;
      var _this2$props6 = _this2.props,
          padding = _this2$props6.padding,
          disabled = _this2$props6.disabled;
      if (disabled || !['ArrowDown', 'ArrowLeft', 'ArrowUp', 'ArrowRight'].includes(e.key)) return;
      e.preventDefault();
      var isPressedLeft = ['ArrowUp', 'ArrowRight'].includes(e.key);

      _this2.setState({
        dragX: getRangedPositionX({
          padding: padding,
          dragX: isPressedLeft ? dragX + _this2.arrowKeyPerClickDistance : dragX - _this2.arrowKeyPerClickDistance,
          maxPositionX: _this2.maxScrollDistance
        })
      });

      _this2.calculateValueAndUpdateStore();
    };

    return _this2;
  }

  _createClass(Slider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$wrapperRef$curr = this.wrapperRef.current.getBoundingClientRect(),
          width = _this$wrapperRef$curr.width;

      var _this$props = this.props,
          value = _this$props.value,
          min = _this$props.min,
          _this$props$padding = _this$props.padding,
          padding = _this$props$padding === void 0 ? 0 : _this$props$padding;

      if (this.controllerRef && this.controllerRef.current) {
        var _this$controllerRef$c = this.controllerRef.current.getBoundingClientRect(),
            controllerWidth = _this$controllerRef$c.width,
            controllerHeight = _this$controllerRef$c.height;

        this.controllerWidth = controllerWidth;
        this.controllerHeight = controllerHeight;
      }

      this.maxScrollDistance = getMaxScrollDistance(width, this.controllerWidth, padding);
      this.arrowKeyPerClickDistance = getDistancePerMove(this.maxScrollDistance, this.totalStepsNumber);
      this.restoreTouchMove = preventScrollOnMobile.call(this);
      window.addEventListener('resize', this.onResize);
      this.setState({
        dragX: this.calculatePositionWithOffset({
          width: width,
          value: value,
          min: min,
          totalStepsNumber: this.totalStepsNumber
        })
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.onKeyEvent);
      document.removeEventListener('mouseup', this.onInteractEnd);
      document.removeEventListener('mousemove', this.onMouseMove);
      window.removeEventListener('resize', this.onResize);
      clearTimeout(this.timer);
      this.restoreTouchMove();
    }
  }, {
    key: "calculateValueAndUpdateStore",
    value: function calculateValueAndUpdateStore() {
      var shouldTriggerOnChange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var _this$props2 = this.props,
          min = _this$props2.min,
          onChange = _this$props2.onChange,
          _this$props2$padding = _this$props2.padding,
          padding = _this$props2$padding === void 0 ? 0 : _this$props2$padding;
      var dragX = this.state.dragX;
      this.value = calculateDragDistance({
        dragDistance: dragX - padding,
        maxPositionX: this.maxScrollDistance,
        totalStepsNumber: this.totalStepsNumber,
        min: min
      });

      if (shouldTriggerOnChange && onChange) {
        onChange(this.value);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          dragX = _this$state.dragX,
          showBubble = _this$state.showBubble,
          isFocusing = _this$state.isFocusing;
      var _this$props3 = this.props,
          hasTickMarks = _this$props3.hasTickMarks,
          textBackgroundColor = _this$props3.textBackgroundColor,
          barColor = _this$props3.barColor,
          textColor = _this$props3.textColor,
          tickColor = _this$props3.tickColor,
          disabled = _this$props3.disabled,
          shouldAnimateOnTouch = _this$props3.shouldAnimateOnTouch,
          shouldDisplayValue = _this$props3.shouldDisplayValue,
          customController = _this$props3.customController,
          max = _this$props3.max,
          min = _this$props3.min,
          _this$props3$barHeigh = _this$props3.barHeight,
          barHeight = _this$props3$barHeigh === void 0 ? 0 : _this$props3$barHeigh,
          _this$props3$barStyle = _this$props3.barStyle,
          barStyle = _this$props3$barStyle === void 0 ? {} : _this$props3$barStyle,
          shouldAnimateNumber = _this$props3.shouldAnimateNumber,
          focusStyle = _this$props3.focusStyle;
      var isThin = barHeight < this.controllerHeight;
      this.calculateValueAndUpdateStore(false);
      return createElement("div", Object.assign({
        style: Object.assign({
          height: "".concat(barHeight, "px"),
          width: '100%',
          borderRadius: '4px',
          background: barColor
        }, isThin ? {
          marginTop: "".concat(this.controllerHeight - barHeight, "px")
        } : {}, {
          position: 'relative',
          MozUserSelect: 'none',
          WebkitUserSelect: 'none',
          msUserSelect: 'none',
          userSelect: 'none'
        }, disabled ? {
          opacity: 0.5,
          cursor: 'not-allowed'
        } : {
          cursor: 'pointer'
        }, barStyle)
      }, this.touchDevice ? {
        onTouchStart: this.onTouchStart,
        onTouchMove: this.onTouchMove
      } : {}, {
        onClick: this.onClick,
        ref: this.wrapperRef
      }), createElement(Controller, {
        isTouchDevice: this.touchDevice,
        focusStyle: focusStyle,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        height: barHeight,
        isFocusing: isFocusing,
        controllerWidth: this.controllerWidth,
        controllerHeight: this.controllerHeight,
        dragX: dragX,
        showBubble: showBubble && !!shouldAnimateOnTouch,
        shouldAnimateNumber: shouldAnimateNumber,
        isControlByKeyBoard: this.isControlByKeyBoard,
        value: this.value,
        shouldDisplayValue: shouldDisplayValue,
        onMouseDown: this.onMouseDown,
        onInteractEnd: this.onInteractEnd,
        barColor: barColor,
        textBackgroundColor: textBackgroundColor,
        textColor: textColor,
        isThin: isThin,
        disabled: disabled,
        customController: customController,
        ref: {
          // @ts-ignore: Unreachable code error
          controllerRootRef: this.controllerRootRef,
          controllerRef: this.controllerRef
        },
        max: max,
        min: min
      }), (hasTickMarks || isThin) && createElement(SliderIndicator, {
        barColor: barColor,
        color: tickColor,
        amount: this.totalStepsNumber,
        isThin: isThin,
        hasTickMarks: hasTickMarks
      }));
    }
  }]);

  return Slider;
}(PureComponent);

Slider.defaultProps = {
  value: 0,
  onChange: function onChange() {},
  barColor: colors.blue,
  textColor: colors.blue,
  textBackgroundColor: colors.white,
  tickColor: colors.lightBlue,
  disabled: false,
  padding: 3,
  hasTickMarks: true,
  shouldAnimateOnTouch: true,
  shouldDisplayValue: true,
  shouldAnimateNumber: true,
  customController: null,
  controllerWidth: 34,
  controllerHeight: 34,
  barHeight: 40,
  barStyle: {}
};
export default Slider;